import { createReducer } from "@reduxjs/toolkit";

import { get, STORAGE_KEYS, save } from "API/LocalStorage";
import { uiSetLanguage } from "Store/Actions";
import { getBrowserLanguage } from "Utils/Translator";

export const Language = createReducer(get<string>(STORAGE_KEYS.LANGUAGE) ?? getBrowserLanguage() ?? `en`, {
  [uiSetLanguage.type]: (_, { payload: language }) => {
    if (!save<string>(STORAGE_KEYS.LANGUAGE, language)) {
      console.warn(`Saving language failed!`);
    }
    return language;
  }
});
